import api from './api';

const fetchCommandErrors = async () => {
  try {
    const { data } = await api.get('/errors');

    return { data: data.data };
  } catch (e) {
    return { errors: e.response?.data?.errors };
  }
};

export default {
  fetchCommandErrors,
};
